import React, { useRef, useState } from "react";
import "./Dashboard.scss";
import LiveLectures from "./section/LiveLectures";
import GroupMeetings from "./section/GroupMeetings";
import { liveLectureList } from "services/liveLecture";
import { useCourse } from "context/context";
import ProgressBar from "./section/ProgressBar";
import { errorResponse, failResponse } from "config/config";
import { charLimit } from "config/utils";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
import TestPerformance from "./section/TestPerformance";
import { getTestByCourse } from "services/dashboard";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PersonalizedLectures from "./section/PersonalizedLectures";
import { BsArrowRight } from "react-icons/bs";
import { DailyQuizimg } from "assets/images";


function Dashboard({ courseDrawerShow, setCourseDrawerShow }) {
  const { course, SpecialLectureflag, mentorfindstudentformflag } = useCourse();
  const { myallCourses } = useCourse();
  const [liveLectures, setLiveLectures] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const [allTests, setAllTests] = useState([]);
  const [selectedTest, setSelectedTest] = useState("");
  const testRef = useRef();

  const testSelectionHandler = ({ target }) => {
    setSelectedTest(target.value);
    testRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const [showCourseSelectModal, setShowCourseSelectModal] = useState(false);
  const [showNoMentorshipModal, setShowNoMentorshipModal] = useState(false);
  const [selectedMentorshipCourse, setSelectedMentorshipCourse] = useState(null);

  const mentorshipCourses = myallCourses?.filter(
    (c) => c.Mentorship === "Y"
  );

  const handleBookAppointment = () => {

    if (mentorshipCourses.length > 0) {

      //setShowCourseSelectModal(true);
      //setShowNoMentorshipModal(true);
      navigate("/dashboard/mentorship-course-selection")

    } else {
      setShowNoMentorshipModal(true);
    }
  };





  // get users live lecture
  const getLiveLectures = async () => {
    try {
      setLoading(true);
      const res = await liveLectureList({ courseIds: [course.courseId] });

      if (res.code === 200) {
        setLiveLectures(res.data.lectures || []);
        setLoading(false);
      } else {
        failResponse(res);
        setLoading(false);
      }
    } catch (err) {
      errorResponse(err);
      setLoading(false);
    }
  };

  // ----------------------- getting live lecture data -------------------------//
  React.useEffect(() => {
    const getAllTestByCourseId = async () => {
      try {
        const res = await getTestByCourse({ courseId: course.courseId });
        if (res.code === 200) {
          setAllTests(res.data);
          setSelectedTest(res.data[0]?.SectionTestID || "");
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      }
    };

    if (course?.courseId) {
      getLiveLectures();
      getAllTestByCourseId();
    }
    // eslint-disable-next-line
  }, [course]);

  return (
    <>
      <section className="dashboard_home ">
        <div className="container">
          {/* My Courses */}

          <div className="mycourses">
            <div className="mycourses_inner mb-2">
              {/* live lecture */}

              <LiveLectures
                loading={loading}
                lectures={liveLectures}
                getLiveLectures={getLiveLectures}
              />

              <div className="_progress_wrapper">
                <GroupMeetings />
              </div>
              {/* user lecture continue watching */}
              {/* <ContinueWatching /> */}
            </div>
          </div>

          {course?.courseId && SpecialLectureflag && (
            <div className="personalized_lectures">
              <PersonalizedLectures />
            </div>
          )}


          <div className="daily_quiz">
            <div className="container">
              <div className="daily_quiz_content">
                <div className="image_wrap">
                  <img src={DailyQuizimg} alt="Shubhra Ranjan" loading="lazy" />
                </div>

                <div className="content">
                  <h4>Take our Daily Quiz</h4>
                  <p>Help sharpen your skills for upcoming exams</p>
                </div>
                <div className="button_wrap fill">
                  <Link to="/dashboard/quiz" className="button">
                    Take quiz
                    <span className="icon">
                      <BsArrowRight />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="chart_wrapper" style={{ marginBottom: "20px" }}>

            <div className="_box _chart_coursewise">
              <h4>Course wise progress</h4>
              <div className="form_field">
                <span
                  className="input_selection"
                  onClick={() => setCourseDrawerShow(true)}
                >
                  {charLimit(course?.courseName, 30) || "My Courses"}
                  <FaAngleDown />
                </span>
                <span>&nbsp;&nbsp;</span>
                <select
                  className="input_selection"
                  value={selectedTest}
                  onChange={testSelectionHandler}
                >
                  <option value="">Select test</option>
                  {allTests.map((data) => {
                    return (
                      <option value={data.SectionTestID} key={data.SectionTestID}>
                        {data.TestTitle}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="_progress_card_wrap">
                <ProgressBar />
                <div className="button_wrap">
                  <Link className="" to={"/dashboard/report"}>
                    View report
                  </Link>
                </div>
              </div>
            </div>

            {/* <div className="_box _chart_mentor">
              <h4>Mentor Appointment Booking</h4>
              <h5>
                The Mentorship Programme is aimed at students preparing for the 2026 UPSC exams. It combines:
              </h5>
              <div className="card_content">
                <ul>
                  <li>A dedicated Prelims test series for GS courses</li>
                  <li>One-on-one mentorship to clear doubts anytime</li>
                  <li>Personalized study plans and progress tracking</li>
                  <li>Live answer writing sessions</li>
                </ul>
              </div>

              <div style={{ textAlign: "center" }}>

                <div style={{ textAlign: "center" }}>
                  <button
                    className="dashboard_button"
                    disabled={!course?.courseId}
                    style={{
                      opacity: !course?.courseId ? 0.6 : 1,
                      pointerEvents: !course?.courseId ? "none" : "auto",
                      cursor: !course?.courseId ? "not-allowed" : "pointer"
                    }}
                    onClick={handleBookAppointment}
                  >
                    Book Appointment
                  </button>
                </div>

              </div>

            </div> */}


          </div>




          {selectedTest && (
            <TestPerformance selectedTest={selectedTest} testRef={testRef} />
          )}
        </div>
      </section>
      <Modal
        show={showCourseSelectModal}
        onHide={() => setShowCourseSelectModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body style={{ padding: "2rem" }}>
          <h4 style={{ fontWeight: 600, marginBottom: "1rem", textAlign: "center" }}>
            Select a Mentorship Course
          </h4>

          {mentorshipCourses.map((course) => (
            <div
              key={course.CourseID}
              style={{
                border: "1px solid #ded1d1",
                padding: "14px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "1rem",
                cursor: "pointer",
                backgroundColor:
                  selectedMentorshipCourse === course.CourseID ? "#f9f9f9" : "#fff",
              }}
              onClick={() => setSelectedMentorshipCourse(course.CourseID)}
            >
              <label
                style={{
                  fontWeight: 500,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "0px"
                }}
              >
                <input
                  type="radio"
                  name="mentorship"
                  value={course.CourseID}
                  checked={selectedMentorshipCourse === course.CourseID}
                  onChange={() => setSelectedMentorshipCourse(course.CourseID)}
                  style={{
                    marginRight: "0.7rem",
                    transform: "scale(1.5)", // 👈 increases radio button size
                    cursor: "pointer",
                  }}
                />
                {course.CourseTitle}
              </label>
            </div>
          ))}


          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "0.5rem",
              marginTop: "2rem"
            }}
          >
            {/* <button
              style={{
                backgroundColor: selectedMentorshipCourse ? "#b91c1c" : "#ccc", // gray when disabled
                color: "#fff",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                cursor: selectedMentorshipCourse ? "pointer" : "not-allowed",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
              onClick={() => {
                if (!selectedMentorshipCourse) return;
                if (mentorfindstudentformflag === true) {

                  navigate("/dashboard/book-mentor-appointment", {
                    state: {
                      fromDashboardMentorModal: true,
                    },
                  })
                } else {
                  navigate('/dashboard/student-mentorship-form', {
                    state: {
                      fromDashboardMentorModal: true
                    }
                  });
                }
              }}
              disabled={!selectedMentorshipCourse}
            >
              Book Appointment
            </button> */}

            <button
              onClick={() => {
                setSelectedMentorshipCourse(null); // Clear selection
                setShowCourseSelectModal(false);   // Close modal
              }}
              style={{
                backgroundColor: "#1e4fa3",
                color: "#fff",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Cancel
            </button>

          </div>
        </Modal.Body>
      </Modal>


      <Modal
        show={showNoMentorshipModal}
        onHide={() => setShowNoMentorshipModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body
          style={{
            padding: "2rem",
            textAlign: "center",
            maxWidth: "500px",
            margin: "0 auto",
          }}
        >
          <h4 style={{ fontWeight: 600, marginBottom: "1rem" }}>
            No Mentorship Course Found
          </h4>

          <p
            style={{
              fontSize: "1rem",
              color: "#555",
              marginBottom: "2rem",
              lineHeight: "1.6",
            }}
          >
            Please subscribe to mentorship courses to avail this feature.
          </p>

          <button
            onClick={() => navigate("/course-listing", {
              state: {
                fromExploreCourseModal: true,
              },
            })
            }
            style={{
              backgroundColor: "#1e4fa3",
              color: "#fff",
              border: "none",
              padding: "0.5rem 1.5rem",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Explore Courses
          </button>
        </Modal.Body>
      </Modal >


    </>
  );
}

export default Dashboard;
